





























































































































































































































































































































































































import Vue from 'vue'
import { PurchaseOrder, Project, Sale, ApiResponse, Contact, RequisitionItem } from '../../interfaces'
import { mapState } from 'vuex'
import DateTimeFormatOptions = Intl.DateTimeFormatOptions
import ContactForm from '@/components/ContactForm.vue'

interface DropdownAction {
  action: string
  purchaseOrder?: PurchaseOrder
  index: number
}

interface MassDropdownAction {
  action: string
}

interface ExistingList {
  list?: string
}

export default Vue.extend({
  name: 'PurchaseOrders',
  components: { ContactForm },
  props: {
    sale: {
      type: Object as () => Sale,
      required: false,
      default: null,
    },
    saleItems: {
      type: Array,
      required: false,
      default: [] as RequisitionItem[],
    },
    activeTab: {
      type: String,
      required: false,
      default: null,
    },
    fetchTrigger: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      busy: false,
      purchaseOrders: [] as PurchaseOrder[],
      activePurchaseOrder: {} as PurchaseOrder,
      showPurchaseOrderModal: false,
      acquereurs: [] as Record<string, string | null>[],
      contactList: [] as Contact[],
      acquereursPhoneNumbers: [] as Record<string, string | null>[],
      saleItemsSearchList: [] as Record<string, string>[],
      saleItemsSearchQuery: '' as string,
      lastPurchaseOrder: {} as PurchaseOrder,
      existingLists: [] as Record<string, string>[],
      selectedList: null as string | null,
      purchaseOrderTypeFilter: 'all' as 'all' | 'phone' | 'fixed',
      itemNumber: null as string | null,
      showAddContactModal: false,
      newContactType: null as string | null,
      newContactId: null as string | null,
      infoPrefill: null as string | null,
      newContact: null as Contact | null,
      resetContactForm: false,
      acquereurId: null as string | null,
      isUpdatingAcquereur: false,
      addons: 0,
      checkAll: false as boolean,
      purchaseOrdersToEdit: [] as number[],
      showMassEditListModal: false,
      massEditListValue: null as string | null,
      showAssignOperatorsModal: false,
      operatorsInput: '' as string,
    }
  },
  computed: {
    ...mapState(['user']),
    isFormDisabled(): boolean {
      return false
    },
    filteredPurchaseOrdersWithLot(): PurchaseOrder[] {
      return this.purchaseOrders.filter((po: PurchaseOrder) => {
        if (!po.requisitionItem) {
          return false
        }

        if (this.selectedList && po.list !== this.selectedList) {
          return false
        }

        if (this.purchaseOrderTypeFilter === 'phone') {
          return po.mustCall === true
        }
        if (this.purchaseOrderTypeFilter === 'fixed') {
          return po.mustCall !== true
        }

        return true
      })
    },
    purchaseOrdersWithLot(): PurchaseOrder[] {
      return this.filteredPurchaseOrdersWithLot
    },
    purchaseOrdersWithoutLot(): PurchaseOrder[] {
      return this.purchaseOrders.filter((po: PurchaseOrder) => !po.requisitionItem)
    },
    itemsChecked(): number {
      return this.purchaseOrdersToEdit.length
    },
    indeterminate(): boolean {
      return this.purchaseOrdersToEdit.length > 0 && this.purchaseOrdersToEdit.length < this.purchaseOrdersWithLot.length
    },
    filteredSaleItemsSearchList(): Record<string, string>[] {
      const saleItemsSearchQuery = this.saleItemsSearchQuery.trim().toLowerCase()
      if (!saleItemsSearchQuery) return this.saleItemsSearchList
      return this.saleItemsSearchList.filter((item) => item.value.toLowerCase() === saleItemsSearchQuery)
    },
  },
  watch: {
    user(newVal) {
      this.addons = newVal.client?.addons ?? 0
    },
    sale(newVal) {
      if (Number.isInteger(newVal.id) && this.activeTab === 'purchaseOrders') {
        this.fetchPurchaseOrders()
        this.activePurchaseOrder.sale = newVal
        this.$emit('fetchSaleItems', newVal.id)
      }
    },
    activeTab(newVal) {
      if (newVal === 'purchaseOrders' && this.sale.id) {
        this.fetchPurchaseOrders()
        this.$emit('fetchSaleItems', this.sale.id)
        this.activePurchaseOrder.sale = this.sale
      }
    },
    saleItems(newVal) {
      if (newVal) {
        newVal.forEach((item: RequisitionItem) => {
          const element = this.saleItemsSearchList.filter((str: Record<string, string>) => {
            return str.value === item.fullItemNumber
          })
          if (element.length === 0) {
            const formattedDescription =
              item?.description && item?.description?.length > 50
                ? `${item?.description?.substring(0, 50)}...`
                : item.description
            const formattedEstimationLow =
              item.estimationLow !== null && item.estimationLow !== undefined && item.estimationLow !== ''
                ? this.formatCurrency(Number(item.estimationLow))
                : '-'
            this.saleItemsSearchList.push({
              value: item.fullItemNumber ?? '',
              label: `${item.fullItemNumber} - ${formattedDescription} - ${formattedEstimationLow}`,
            })
          }
        })
      }
    },
    newContact(newVal) {
      if (newVal !== null) {
        switch (this.newContactType) {
          case 'acquereur':
            this.updateAcquereur(newVal)
            break
        }
        this.newContact = null
        this.newContactType = ''
      }
    },
    fetchTrigger() {
      this.fetchPurchaseOrders()
    },
    selectedList() {
      this.checkAll = false
      this.purchaseOrdersToEdit = []
    },
    purchaseOrderTypeFilter() {
      this.checkAll = false
      this.purchaseOrdersToEdit = []
    },
  },
  mounted() {
    if (this.user) {
      this.addons = this.user.client?.addons ?? 0
    }
    if (Number.isInteger(this.sale.id) && this.activeTab === 'purchaseOrders') {
      this.activePurchaseOrder.sale = this.sale
      this.fetchPurchaseOrders()
      this.$emit('fetchSaleItems', this.sale.id)
    }
  },
  methods: {
    toggleCheckAll(status: boolean) {
      this.purchaseOrdersWithLot.forEach((po: PurchaseOrder) => {
        this.$set(po, 'isChecked', status)
      })
      this.purchaseOrdersToEdit = status
        ? this.purchaseOrdersWithLot.map((po: PurchaseOrder) => po.id ?? -1).filter((id) => id > -1)
        : []
      this.checkAll = status
    },
    toggleCheck(po: PurchaseOrder, checked: boolean) {
      const poId = po.id ?? -1
      const idx = this.purchaseOrdersToEdit.indexOf(poId)
      if (checked && idx === -1) {
        this.purchaseOrdersToEdit.push(poId)
      } else if (!checked && idx !== -1) {
        this.purchaseOrdersToEdit.splice(idx, 1)
      }
      this.checkAll = this.purchaseOrdersToEdit.length === this.purchaseOrdersWithLot.length
    },
    handleMassCommand(command: MassDropdownAction) {
      if (command.action === 'massEditList') {
        this.massEditListValue = null
        this.showMassEditListModal = true
      }
      if (command.action === 'massDelete') {
        this.massDeletePurchaseOrders()
      }
    },
    confirmMassEditList() {
      this.$api
        .post(`/purchase-order/mass-edit-list`, {
          ids: this.purchaseOrdersToEdit,
          list: this.massEditListValue,
        })
        .then((response) => {
          const apiResponse = response.data as ApiResponse
          this.$notify({
            type: 'success',
            title: 'Succès',
            message: apiResponse.message ?? `Liste modifiée avec succès.`,
          })
          this.showMassEditListModal = false
          this.fetchPurchaseOrders()
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Erreur',
            message: 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
          })
        })
    },
    massDeletePurchaseOrders() {
      const count = this.purchaseOrdersToEdit.length
      this.$confirm(
        `Êtes-vous sûr(e) de vouloir supprimer ces ${count} ordre(s) d'achat ?`,
        'Confirmation',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning',
        }
      ).then(() => {
        this.busy = true
        const promises = this.purchaseOrdersToEdit.map((id: number) =>
          this.$api.delete(`/purchase-order/${id}`)
        )
        Promise.all(promises)
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Succès',
              message: `${count} ordre(s) d'achat supprimé(s) avec succès.`,
            })
            this.busy = false
            this.fetchPurchaseOrders()
          })
          .catch(() => {
            this.$notify({
              type: 'error',
              title: 'Erreur',
              message: 'Une erreur est survenue lors de la suppression.',
            })
          })
          .finally(() => {
            this.busy = false
          })
      })
    },
    addonTest(code: number) {
      if (!isNaN(this.addons)) {
        return BigInt(code) & BigInt(this.addons)
      } else {
        return false
      }
    },
    formatCurrency(number: number): string {
      return Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(number).toString()
    },
    formatDescription(purchaseOrder: PurchaseOrder): string {
      if (purchaseOrder) {
        const str = purchaseOrder.requisitionItem?.description ?? ''
        return str.length > 100 ? `${str.substring(0, 100).trim()}...` : str
      }
      return ''
    },
    formatDate(str: string): string {
      const date = Date.parse(str)
      if (!isNaN(date)) {
        const dateOptions = {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
        } as DateTimeFormatOptions
        return new Intl.DateTimeFormat('fr-FR', dateOptions).format(date)
      } else {
        return '-'
      }
    },
    formatAcquereurName(purchaseOrder: PurchaseOrder, emptyIfUndefined = false) {
      const emptyName = !emptyIfUndefined ? '-' : ''
      return purchaseOrder.acquereur ? purchaseOrder.acquereur?.formName : emptyName
    },
    formatAcquereurPhone(purchaseOrder: PurchaseOrder) {
      if (purchaseOrder.mustCall && purchaseOrder.acquereurPhoneNumber) {
        return purchaseOrder.acquereurPhoneNumber ?? '-'
      }

      return '-'
    },
    fetchPurchaseOrders() {
      if (!this.busy) {
        this.busy = true

        this.$api
          .get(`/purchase-order/list/${this.sale?.id}`)
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            this.purchaseOrders = apiResponse.data.purchaseOrders
            this.checkAll = false
            this.purchaseOrdersToEdit = []
            if (apiResponse.data.lastPlateNumber && apiResponse.data.lastAcquereur) {
              this.lastPurchaseOrder = {
                plateNumber: apiResponse.data.lastPlateNumber,
                acquereur: apiResponse.data.lastAcquereur,
                acquereurPhoneNumber: apiResponse.data.lastAcquereurPhoneNumber,
              }
            }
          })
          .finally(() => {
            this.busy = false
            this.fetchPurchaseOrderSavedList()
          })
      }
    },
    fetchPurchaseOrderSavedList() {
      if (!this.busy) {
        this.$api
          .get(`/purchase-order/${this.sale?.id}/saved-lists`)
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            if (apiResponse.data.length > 0) {
              this.existingLists = []
              apiResponse.data.forEach((existingList: ExistingList) => {
                this.existingLists.push({
                  value: existingList.list ?? '',
                })
              })
            }
          })
          .finally(() => {
            this.busy = false
          })
      }
    },
    savePurchaseOrder() {
      const data = {
        ...this.activePurchaseOrder,
        sale: this.sale.id,
        acquereur: this.getLastAcquereur()?.value,
        itemNumber: this.itemNumber,
      }
      let success = false
      this.setLastPurchaseOrder()
      this.$api
        .post('/purchase-order', data)
        .then((response) => {
          const apiResponse = response.data as ApiResponse

          const lastPurchaseOrder = apiResponse.data

          this.purchaseOrders.unshift(apiResponse.data)

          if (apiResponse.data) {
            this.lastPurchaseOrder = {
              plateNumber: lastPurchaseOrder.plateNumber,
              acquereur: lastPurchaseOrder.acquereur,
              acquereurPhoneNumber: lastPurchaseOrder.acquereurPhoneNumber,
            }
            if (this.filterExistingList(apiResponse.data.list, true)?.length === 0) {
              this.existingLists.push({
                value: apiResponse.data.list,
              })
            }
          }
          this.$notify({
            type: 'success',
            title: 'Succès',
            message: `Ordre d'achat créé avec succès !`,
          })
          success = true
        })
        .catch((error) => {
          if (error.response) {
            const apiResponse = error.response.data as ApiResponse

            this.$notify({
              type: 'error',
              title: 'Erreur',
              message:
                apiResponse.message ?? 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
            })
            if (apiResponse.data.lastPlateNumber && apiResponse.data.lastAcquereur) {
              this.lastPurchaseOrder = {
                plateNumber: apiResponse.data.lastPlateNumber,
                acquereur: apiResponse.data.lastAcquereur,
                acquereurPhoneNumber: apiResponse.data.lastAcquereurPhoneNumber,
              }
            }
          }
        })
        .finally(() => {
          this.busy = false
          if (success) {
            this.resetPurchaseOrderModal()
            this.focusLotConcernedSelect()
          }
        })
    },
    updatePurchaseOrder() {
      let data = {
        ...this.activePurchaseOrder,
        sale: this.sale.id,
        itemNumber: this.itemNumber,
      } as Record<string, string | number | boolean | null>

      if (this.acquereurId) {
        data.acquereur = this.acquereurId
      } else {
        data.acquereur = null
      }

      let success = false
      this.$api
        .put(`/purchase-order/${this.activePurchaseOrder.id}`, data)
        .then((response) => {
          const apiResponse = response.data as ApiResponse

          const index = this.searchPurchaseOrder(this.activePurchaseOrder.id) ?? -1
          if (index > -1) {
            this.purchaseOrders.splice(index, 1, apiResponse.data.updatedPurchaseOrder)
            if (apiResponse.data.lastPlateNumber && apiResponse.data.lastAcquereur) {
              this.lastPurchaseOrder = {
                plateNumber: apiResponse.data.lastPlateNumber,
                acquereur: apiResponse.data.lastAcquereur,
                acquereurPhoneNumber: apiResponse.data.lastAcquereurPhoneNumber,
              }
            }
            if (apiResponse.data.list && this.filterExistingList(apiResponse.data.list, true)?.length === 0) {
              this.existingLists.push({
                value: apiResponse.data.list,
              })
            }
          } else {
            this.purchaseOrders = []
            this.fetchPurchaseOrders()
          }
          this.$notify({
            type: 'success',
            title: 'Succès',
            message: `Ordre d'achat modifié avec succès !`,
          })
          success = true
        })
        .catch((error) => {
          if (error.response) {
            const apiResponse = error.response.data as ApiResponse

            this.$notify({
              type: 'error',
              title: 'Erreur',
              message:
                apiResponse.message ?? 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
            })
          }
        })
        .finally(() => {
          this.busy = false
          if (success) {
            this.closeEditPurchaseOrderModal()
          }
        })
    },
    deletePurchaseOrder(purchaseOrder: PurchaseOrder) {
      if (!this.busy) {
        this.$confirm(
          "Êtes-vous sûr(e) de vouloir supprimer cet ordre d'achat ?",
          'Confirmation',
          {
            confirmButtonText: 'OK',
            cancelButtonText: 'Annuler',
            type: 'warning',
          }
        ).then(() => {
          this.busy = true

          this.$api
            .delete(`/purchase-order/${purchaseOrder?.id}`)
            .then(() => {
              this.busy = false
              this.fetchPurchaseOrders()
              this.$notify({
                type: 'success',
                title: 'Succès',
                message: `Ordre d'achat supprimé avec succès.`,
              })
            })
            .catch(() => {
              this.$notify({
                type: 'error',
                title: 'Erreur',
                message:
                  'Une erreur est survenue lors de la suppression. Veuillez nous excuser pour la gêne occasionnée.',
              })
            })
            .finally(() => {
              this.busy = false
              this.fetchPurchaseOrderSavedList()
            })
        })
      }
    },
    filterExistingList(search: string, returnEmpty = false) {
      const returnEmptyValue = returnEmpty ? [] : this.existingLists
      return search
        ? this.existingLists?.filter(
            (str: Record<string, string>) => str.value?.toLowerCase().indexOf(search.toLowerCase()) === 0 ?? null
          )
        : returnEmptyValue
    },
    searchExistingList(search: string, cb: CallableFunction) {
      const results = this.filterExistingList(search)
      cb(results)
    },
    openAssignOperatorsModal() {
      this.operatorsInput = ''
      this.showAssignOperatorsModal = true
    },
    confirmAssignOperators() {
      if (!this.operatorsInput || this.operatorsInput.trim() === '') {
        this.$notify({
          type: 'warning',
          title: 'Attention',
          message: 'Veuillez renseigner au moins un opérateur.',
        })
        return
      }
      this.$api
        .post(`/purchase-order/assign-operators/${this.sale?.id}`, {
          operators: this.operatorsInput,
        })
        .then((response) => {
          const apiResponse = response.data as ApiResponse
          if (apiResponse.success === true) {
            this.$notify({
              type: 'success',
              title: 'Succès',
              message: apiResponse.message ?? "Répartition des ordres d'achat effectuée avec succès.",
            })
            this.showAssignOperatorsModal = false
            this.fetchPurchaseOrders()
          }
        })
    },
    printPurchaseOrdersList() {
      this.downloadPurchaseOrderPrint(this.selectedList ?? '', this.purchaseOrderTypeFilter)
    },
    downloadPurchaseOrderPrint(list = '', type: 'all' | 'phone' | 'fixed' = 'all') {
      this.$api
        .post(`/purchase-order/print`, {
          list,
          sale: this.sale?.id,
          type,
        })
        .then((response) => {
          const apiResponse = response.data as ApiResponse

          // const documentUrl = `${process.env.VUE_APP_API_URL}/purchase-order/${apiResponse.data}/download`
          // window.open(documentUrl, '_blank')
          if (apiResponse.success === true) {
            const documentUrl = `${process.env.VUE_APP_API_URL}/document/${apiResponse.data.filename}/download_once?contentd=inline`
            window.open(documentUrl, '_blank')
          }
        })
    },
    handlePurchaseOrderCommand(command: DropdownAction) {
      // Edit requisition item
      if (command.action == 'edit' && command.purchaseOrder) {
        this.openEditPurchaseOrder(command.purchaseOrder)
      }
      if (command.action == 'delete' && command.purchaseOrder) {
        this.deletePurchaseOrder(command.purchaseOrder)
      }
    },
    handlePurchaseOrderRowClick(
      purchaseOrder: PurchaseOrder,
      column: { property?: string; className?: string }
    ) {
      const isLotColumn = column.property === 'fullItemNumber'
      const isTechnicalColumn = !column.property || column.className?.includes('no-edit-click')
      if (isLotColumn || isTechnicalColumn) {
        return
      }

      this.openEditPurchaseOrder(purchaseOrder)
    },
    setLastPurchaseOrder() {
      this.lastPurchaseOrder = {
        plateNumber: this.activePurchaseOrder.plateNumber,
        acquereur: this.getLastAcquereur(),
        acquereurPhoneNumber: this.activePurchaseOrder.acquereurPhoneNumber,
      }
    },
    openEditPurchaseOrder(purchaseOrder?: PurchaseOrder) {
      // Open modal
      this.showPurchaseOrderModal = true
      if (purchaseOrder) {
        this.activePurchaseOrder = {
          ...purchaseOrder,
        }
        this.itemNumber = this.activePurchaseOrder.requisitionItem?.fullItemNumber ?? null
        if (this.activePurchaseOrder.acquereur) {
          this.acquereurs = [
            {
              label: this.activePurchaseOrder.acquereur?.formName ?? null,
              value: this.activePurchaseOrder.acquereur?.id?.toString() ?? null,
            },
          ]
        } else {
          this.acquereurs = []
        }
        this.acquereurId = this.activePurchaseOrder.acquereur?.id?.toString() ?? null
      } else {
        this.activePurchaseOrder = {
          ...this.lastPurchaseOrder,
          mustCall: false,
        }
        if (this.lastPurchaseOrder.acquereur) {
          this.acquereurs = [
            {
              label: this.lastPurchaseOrder.acquereur?.formName ?? null,
              value: this.lastPurchaseOrder.acquereur?.id?.toString() ?? null,
            },
          ]
        }
        this.acquereurId = this.activePurchaseOrder.acquereur?.id?.toString() ?? null
      }
      this.activePurchaseOrder.sale = this.sale
    },
    closeEditPurchaseOrderModal() {
      this.showPurchaseOrderModal = false
      this.activePurchaseOrder = {}
      this.acquereurs = []
    },
    resetPurchaseOrderModal() {
      this.activePurchaseOrder = {
        ...this.activePurchaseOrder,
        mustCall: false,
      }
      delete this.activePurchaseOrder.id
      delete this.activePurchaseOrder.amount
      // delete this.activePurchaseOrder.itemNumber
      delete this.activePurchaseOrder.list

      this.itemNumber = null
    },
    focusLotConcernedSelect() {
      this.$nextTick(() => {
        const lotConcernedSelect = this.$refs.lotConcernedSelect as Vue & { focus?: () => void }
        lotConcernedSelect?.focus?.()
      })
    },
    searchPurchaseOrder(purchaseOrderId?: number | null) {
      if (!purchaseOrderId) return -1
      return this.purchaseOrders.findIndex((purchaseOrder: PurchaseOrder) => purchaseOrder?.id === purchaseOrderId)
    },
    goToRequisitionItem(row: PurchaseOrder): void {
      const requisitionItem = row.requisitionItem ?? null
      if (requisitionItem) {
        const project = requisitionItem.requisition?.project as Project
        if (project) {
          this.$router.push({
            name: 'requisition_item_edit',
            params: {
              itemId: requisitionItem.id?.toString() ?? '',
            },
            query: {
              backTo: this.$route.name,
            },
          })
        }
      }
    },
    searchAcquereurs(search?: string) {
      if (search && search.length >= 2) {
        this.acquereurs = this.searchContacts(search)
      }
    },
    searchContacts(search?: string): Record<string, string | null>[] {
      this.busy = true
      const acquereurs = [] as Record<string, string | null>[]

      if (search) {
        this.infoPrefill = search
      }

      this.acquereursPhoneNumbers = []
      this.$api
        .get('/contacts', {
          params: {
            search: search ?? null,
          },
        })
        .then((response) => {
          const apiResponse = response.data as ApiResponse
          if (apiResponse.data && Array.isArray(apiResponse.data)) {
            this.contactList = apiResponse.data
            apiResponse.data.forEach((contact: Contact) => {
              let contactLabel = contact.formName
              if (contact.city) {
                contactLabel = `${contact.formName} - ${contact.city}`
              }
              acquereurs.push({
                label: contactLabel ?? null,
                value: contact.id?.toString() ?? null,
              })
              const contactPhoneNumbers = [contact.mobile, contact.phone, contact.fax]
                .map((phoneNumber) => phoneNumber?.trim() ?? '')
                .filter((phoneNumber) => phoneNumber && phoneNumber.toLowerCase() !== 'null')
              const phoneNumber = contactPhoneNumbers.join(' / ')
              this.acquereursPhoneNumbers.push({
                label: phoneNumber || null,
                value: contact.id?.toString() ?? null,
              })
            })
          }
        })
        .finally(() => {
          this.busy = false
        })
      return acquereurs
    },
    changeAcquereur(id: string, type: string) {
      if (this.isUpdatingAcquereur) return
      if (id === 'add') {
        this.acquereurId = null
        this.openContactForm(type)
      } else {
        this.activePurchaseOrder = {
          ...this.activePurchaseOrder,
          acquereur: this.contactList.find((contact: Contact) => contact.id?.toString() === id),
          acquereurPhoneNumber: this.acquereursPhoneNumbers.find((acquereur) => acquereur.value === id)?.label ?? '',
          plateNumber: null,
        }
      }
    },
    clearNewContact() {
      this.acquereurs = []
      this.activePurchaseOrder.acquereur = null
      this.newContactId = null
      this.infoPrefill = null
    },
    openContactForm(type: string, contactId?: string) {
      this.showAddContactModal = true
      this.newContactType = type
      this.newContactId = contactId ?? null
      this.infoPrefill = null
      this.resetContactForm = !this.resetContactForm
    },
    closeContactModal() {
      this.showAddContactModal = false
      this.infoPrefill = null
    },
    updateNewContact(contact: Contact) {
      this.showAddContactModal = false
      this.newContactType = 'acquereur'
      this.newContact = contact
    },
    updateAcquereur(contact: Contact) {
      if (contact?.id !== null) {
        this.isUpdatingAcquereur = true
        this.acquereurs = [
          {
            label: contact?.formName ?? null,
            value: contact?.id?.toString() ?? null,
          },
        ]
        this.$set(this.activePurchaseOrder, 'acquereur', contact ?? null)
        this.$set(this.activePurchaseOrder, 'plateNumber', null)
        this.$set(this.activePurchaseOrder, 'acquereurPhoneNumber', contact.mobile ?? contact.phone ?? '')
        this.acquereurId = contact.id?.toString() ?? null
        this.$nextTick(() => {
          this.isUpdatingAcquereur = false
        })
      }
    },
    getLastAcquereur() {
      return this.acquereurs.find((acquereur) => {
        if (this.activePurchaseOrder.acquereur?.id !== undefined) {
          return acquereur.value === this.activePurchaseOrder.acquereur?.id?.toString()
        } else {
          return acquereur.value === this.activePurchaseOrder.acquereur?.toString()
        }
      })
    },
    acquereurSort(itemA: PurchaseOrder, itemB: PurchaseOrder) {
      const fullNameA = this.formatAcquereurName(itemA, true) ?? ''
      const fullNameB = this.formatAcquereurName(itemB, true) ?? ''
      if (fullNameA == fullNameB) {
        return 0
      }

      return fullNameA < fullNameB ? -1 : 1
    },
    itemNumberSort(itemA: PurchaseOrder, itemB: PurchaseOrder) {
      const itemNumberA = this.convertItemNumber(itemA) ?? 0
      const itemNumberB = this.convertItemNumber(itemB) ?? 0
      if (itemNumberA == itemNumberB) {
        return 0
      }

      return itemNumberA < itemNumberB ? -1 : 1
    },
    convertItemNumber(purchaseOrder: PurchaseOrder) {
      return parseFloat(purchaseOrder.requisitionItem?.fullItemNumber?.replace('-', '.') ?? '')
    },
    filterSaleItems(query: string) {
      this.saleItemsSearchQuery = query
    },
    selectFirstFilteredSaleItem() {
      if (!this.saleItemsSearchQuery.trim()) return

      const [firstSaleItem] = this.filteredSaleItemsSearchList
      if (firstSaleItem) {
        this.itemNumber = firstSaleItem.value
      }
    },
    checkMustCall() {
      if (
        this.showPurchaseOrderModal &&
        this.activePurchaseOrder.list !== undefined &&
        this.activePurchaseOrder.list !== ''
      ) {
        this.activePurchaseOrder = {
          ...this.activePurchaseOrder,
          mustCall: true,
        }
      }
    },
  },
})
